import { Button } from "@/components/ui/button";
import { Lock, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

interface FeatureUpgradeCardProps {
  featureName: string;
  description?: string;
}

export const FeatureUpgradeCard = ({ featureName, description }: FeatureUpgradeCardProps) => {
  return (
    <div className="app-tile p-8 text-center border-dashed">
      <div className="mx-auto w-12 h-12 rounded-full bg-muted flex items-center justify-center mb-3">
        <Lock className="h-5 w-5 text-muted-foreground" />
      </div>
      <h3 className="app-section-title text-lg mb-1">{featureName}</h3>
      <p className="text-sm text-muted-foreground mb-5 max-w-md mx-auto">
        {description || `${featureName} is available on Pro plan and above. Upgrade to unlock it.`}
      </p>
      <Button asChild className="shadow-fluent-2">
        <Link to="/plans" className="gap-2">
          Upgrade to Pro
          <ArrowUpRight className="h-4 w-4" />
        </Link>
      </Button>
    </div>
  );
};
